












import Vue from 'vue';
import { mapGetters } from 'vuex';

import Track from '../Track/Track.vue';
import StepsDisplay from './StepsDisplay.vue';

export default Vue.extend({
  name: 'Patterns',
  components: {
    Track,
    StepsDisplay
  },
  computed: {
    ...mapGetters(['tracks'])
  }
});
